module.exports = __webpack_public_path__ + "static/img/03.9b651526.png";